import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Row } from 'reactstrap';
import { isLoggedIn } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import Sidebar from './sidebar/Sidebar';
import Topbar from './topbar/Topbar';

interface Props extends LocalizeContextProps, RouteComponentProps {
    isLoggedIn: boolean;
}

class DashboardContainer extends React.Component<Props> {
    public render() {
        // This is checked so that the dashboard doesn't render on a default redirect
        if (this.props.isLoggedIn) {
            return (
                <Row className="sidebar-row">
                    <Sidebar />
                    <Topbar />
                    <div className="side-body body-slide-in">
                        {this.props.children}
                    </div>
                </Row>
            );
        } else {
            return this.props.children;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoggedIn: isLoggedIn(state)
});
export default connect(mapStateToProps)(withLocalize(withRouter(DashboardContainer)));